import { render, staticRenderFns } from "./AstaNav.vue?vue&type=template&id=132a0284&scoped=true&"
import script from "./AstaNav.vue?vue&type=script&lang=js&"
export * from "./AstaNav.vue?vue&type=script&lang=js&"
import style0 from "./AstaNav.vue?vue&type=style&index=0&id=132a0284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132a0284",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('132a0284')) {
      api.createRecord('132a0284', component.options)
    } else {
      api.reload('132a0284', component.options)
    }
    module.hot.accept("./AstaNav.vue?vue&type=template&id=132a0284&scoped=true&", function () {
      api.rerender('132a0284', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AstaNav.vue"
export default component.exports